import { Action, createReducer, on } from '@ngrx/store';
import {
    logout,
    removeSocialLink,
    removeSocialLinkCancelled,
    removeSocialLinkConfirmed,
    sessionExpired,
    sessionExpiredConfirmed
} from './login.actions';
import { LoginState } from './login.state';

const initialState: LoginState = {
    sessionExpired: false,
    removingSocialLink: false
};

const reducer = createReducer(
    initialState,
    on(sessionExpired, (state) => ({ ...state, sessionExpired: true })),
    on(sessionExpiredConfirmed, (state) => ({ ...state, sessionExpired: false })),
    on(removeSocialLink, (state) => ({ ...state, removingSocialLink: true })),
    on(removeSocialLinkConfirmed, (state) => ({ ...state, removingSocialLink: false })),
    on(removeSocialLinkCancelled, (state) => ({ ...state, removingSocialLink: false })),
    on(logout, () => ({ ...initialState }))
);

export function loginReducer(state: LoginState | undefined, action: Action): any {
    return reducer(state, action);
}
